import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { db } from "../../firebase";

function DropDownRoomsNumber(props) {
  const [roomNumbers, setRoomNumbers] = useState([]);
  const [selectedRoomNumber, setSelectedRoomNumber] = useState(
    props.value || ""
  );
  const [isUpdating] = useState(false);

  // Synchroniser props.value avec l'état local
  useEffect(() => {
    setSelectedRoomNumber(props.value);
  }, [props.value]);

  const handleChange = (event) => {
    const newRoomNumber = event.target.value;
    setSelectedRoomNumber(newRoomNumber);
    props.onChange(newRoomNumber); // Le parent fait tout
  };

  useEffect(() => {
    const predefinedRooms = [
      "1A",
      "1B",
      "1C",
      "2A",
      "2B",
      "2C",
      "3A",
      "3B",
      "3C",
      "4A",
      "4B",
      "4C",
      "5A",
      "5B",
      "5D",
      "5E",
      "6A",
      "6B",
      "6D",
      "6E",
      "7A",
      "7B",
      "7D",
      "7E",
      "8E",
      "8A",
      "8D",
      "8B",

      // "Room 1",
      // "Room 2",
      // "Room 3",
    ];

    const roomCollection = collection(db, "RoomNumbers");

    const unsubscribe = onSnapshot(roomCollection, (snapshot) => {
      const occupiedRooms = snapshot.docs.map((doc) => doc.id);
      console.log("Chambres occupées :", occupiedRooms);
      const availableRooms = predefinedRooms.filter(
        (room) => !occupiedRooms.includes(room)
      );
      console.log("Chambres disponibles :", availableRooms);
      setRoomNumbers(availableRooms);
    });

    return () => unsubscribe();
  }, []);

  const renderOptions = () => {
    return (
      <>
        <option value="">--Choose a room number--</option>
        {roomNumbers.map((room) => (
          <option key={room} value={room}>
            {room}
          </option>
        ))}
        {/* Affiche l'option de la chambre sélectionnée si elle est occupée */}
        {!roomNumbers.includes(selectedRoomNumber) && selectedRoomNumber && (
          <option value={selectedRoomNumber}>
            {selectedRoomNumber} (Occupied)
          </option>
        )}
      </>
    );
  };

  return (
    <div
      className="input-label-container"
      style={{ display: "flex", alignItems: "center" }}
    >
      <div className="input-label-dropdown">
        {props.title}{" "}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
      <TextField
        className="dropdown-select"
        SelectProps={{
          native: true,
          style: { height: 40 },
        }}
        select
        value={selectedRoomNumber} // Utilisez l'état local ici
        onChange={handleChange}
        style={{ width: props.width || "auto", marginRight: 8 }}
      >
        {renderOptions()}
      </TextField>
      {isUpdating && <CircularProgress size={24} />}{" "}
      {/* Affiche le spinner pendant la mise à jour */}
    </div>
  );
}

export default DropDownRoomsNumber;
